import { useRef, useState } from "react";
import {
  PERSONAL_CHAT_NAME_MAX_LENGTH,
  personalChatNameError,
} from "../../../shared/personalChatName";
import { Button } from "../Button";
import { Input } from "../Input";
import { Modal } from "../Modal";
import { ModalContent, ModalFooter } from "../ModalCard";
import { Text } from "../Text";

type Props = {
  initialName: string;
  onClose: () => void;
  onRename: (name: string) => void;
};

export function RenamePersonalChatModal({
  initialName,
  onClose,
  onRename,
}: Props) {
  const [name, setName] = useState(initialName);
  const inputRef = useRef<HTMLInputElement>(null);
  const trimmed = name.trim();
  const error = personalChatNameError(trimmed);

  const submit = () => {
    if (error) return;
    if (trimmed !== initialName) onRename(trimmed);
    onClose();
  };

  return (
    <Modal open onClose={onClose} alert initialFocusRef={inputRef}>
      <ModalContent>
        <Text variant="text-regular-md" color="var(--text-primary)">
          Rename chat
        </Text>
        <Input
          ref={inputRef}
          aria-label="Chat name"
          value={name}
          maxLength={PERSONAL_CHAT_NAME_MAX_LENGTH}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.nativeEvent.isComposing) {
              e.preventDefault();
              submit();
            }
          }}
        />
        {trimmed && error && (
          <Text variant="text-small" color="var(--red-600)">
            {error}
          </Text>
        )}
        <ModalFooter>
          <Button size="l" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button size="l" disabled={error !== null} onClick={submit}>
            Rename
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
